<template>
    <div class="history-item__body">  
        <template  v-if="item">  
            <div class="history-item__left">
                <div class="history-item__title">
                    <!-- Input parameters  -->
                </div>
                 
                <div class="history-item__parameters"> 
                    <ul class="history-item__ul">
                        <li class="history-item__li">
                            Number of orders: <span> {{item.orders_quantity}}</span>
                        </li> 
                        <li class="history-item__li">
                            Number of handymen: <span> {{item.masters_quantity}}</span>
                        </li>  
                        <li class="history-item__li">
                            Number of days: <span>{{getNumberOfDays(item.simulation_from, item.simulation_to)}}</span>
                        </li>
                        <li class="history-item__li">
                            Date of simulation: <span>{{dateFormat(item.created_at, 'l')}}</span>
                        </li>   
                        <li class="history-item__li">
                            From/to <span>{{dateFormat(item.simulation_from, 'l')}} - {{dateFormat(item.simulation_to, 'l')}}</span>
                        </li> 

                        <li class="history-item__li">
                            Schedule from/to <span>{{item.schedule_from}}/{{item.schedule_to}}</span>
                        </li> 

                        <li class="history-item__li">
                            Order duration from/till: <span>{{numberToHour(item.duration_from)}}/{{numberToHour(item.duration_to)}}</span>
                        </li>

                        <li class="history-item__li">
                            Canceled requests by clients: <span>{{item.request.orders.canceled}}%</span>
                        </li> 

                        <li class="history-item__li">
                            Percent of clients agree to transfer request: <span>{{item.request.orders.carry_over}}%</span>
                        </li> 

                        <li class="history-item__li">
                            Handymen absent daily: <span>{{item.request.masters.working_timesheet.not_go_work}}%</span>
                        </li>  
                    </ul>
 
                    <ul class="history-item__ul"> 
                        <li class="history-item__li">
                           Handymen efficiency (working hours minus inactive time minus travel time): <span> {{item.indicators.sold_hours}}%</span>
                        </li>   

                         <li class="history-item__li">
                            Travel time: <span>{{item.indicators.in_the_way }}%</span>
                        </li>

                        <li class="history-item__li">
                            Inactive time: <span>{{item.indicators.inactive || 0}}%</span>
                        </li>

                        <li class="history-item__li"></li> 
                        <li class="history-item__li"></li>   

                        <li class="history-item__li">
                            First DoS: <span> {{item.indicators.first_denied}}%</span>
                        </li>   

                        <li class="history-item__li">
                            Final DoS: <span>  {{item.indicators.final_denied}}%</span>
                        </li>  
                        
                        <li class="history-item__li">
                            Completed: <span>  {{100 - item.indicators.final_denied}}%</span>
                        </li>

                        <li class="history-item__li">
                            Transfer:<span>  {{item.indicators.carry_over}}%</span> 
                        </li> 

                        <li class="history-item__li"></li> 
                        <li class="history-item__li"></li>   

                        <li class="history-item__li">
                            Booked hours / paid hours 
                            <span>
                                {{ item.indicators.requested_hours}}/{{item.indicators.completed_hours}} h
                            </span> 
                        </li>   
                    </ul>
                </div>  
            </div>

            <div class="history-item__right"> 
                <slot></slot>
            </div>
        </template>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import dateMixin from '@/mixins/dateMixin';

export default {
    name: 'history',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    mixins: [dateMixin]
}
</script>

<style lang="scss" scoped>
.inactive {
    opacity: 0.3;
}
</style>